<template>
  <sideBarView />

  <navbarView />

  <main class="main-sec hidden-over" id="main">
    <div class="container">
      <div class="side-heading">
        <h6>{{ $t('reviewsView.title') }}</h6>
        <p class="font14 gray-col">{{ $t('reviewsView.subtitle') }}</p>
      </div>
      <div class="reviews-page">
        <div v-if="!loader">
          <clientsReviews :rates="reviews" v-if="reviews?.length"/>
          <p v-else class="font15 gray-col mt-4 text-center">{{ $t('reviewsView.noReviews') }}</p>
        </div>
        <div v-else class="mt-4 bg-white-div">
          <Skeleton width="100%" height="80px" class="mb-3"></Skeleton>
          <Skeleton width="100%" height="80px" class="mb-3"></Skeleton>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
// imports
import sideBarView from "../components/dashboard/sideBarView.vue";
import navbarView from "../components/dashboard/navbarView.vue";
import clientsReviews from "../components/dashboard/clientsReviews.vue";
import axios from "axios";
import Skeleton from "primevue/skeleton";
import { onMounted, ref } from "vue";

// reactive state
const reviews = ref([]);
const loader = ref(false);

// functions
function getReviews() {
  loader.value = true;
  axios
    .get("/manager/rates", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then((response) => {
      reviews.value = response.data.data;
      loader.value = false;
    });
}

// lifecycle hooks
onMounted(() => {
  getReviews();
});
</script>
